var React = require('react');

function Size (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.8 21.2c0 .6.4 1 1 1h7c.6 0 1-.4 1-1 0-.3-.1-.5-.3-.7L8 18.1c-.1-.1-.1-.3 0-.4L17.8 8c.1-.1.3-.1.4 0l2.4 2.4c.2.2.4.3.7.3.1 0 .3 0 .4-.1.4-.2.6-.5.6-.9v-7c0-.6-.4-1-1-1h-7c-.6 0-1 .4-1 1 0 .3.1.5.3.7L16 5.9c.1.1.1.3 0 .4L6.2 16c-.1.1-.3.1-.4 0l-2.4-2.4c-.4-.4-1-.4-1.4 0-.2.2-.3.4-.3.7l.1 6.9z"}));
}

Size.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Size;

Size.default = Size;
